import type { CSSProperties } from 'react';
import { useListRow } from '../List/ListRowContext';

interface BadgeProps {
  text: string;
  color?: string;
  field?: string;
  className?: string;
  style?: CSSProperties;
}

const COLOR_MAP: Record<string, string> = {
  green: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  gray: 'bg-muted text-muted-foreground',
};

export function BadgeView({ text, color = 'gray', field, className, style }: BadgeProps) {
  const row = useListRow();
  const displayText = field && row ? String(row[field] ?? text) : text;
  const colorClass = COLOR_MAP[color] ?? COLOR_MAP.gray;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${colorClass}${className ? ` ${className}` : ''}`}
      style={style}
    >
      {displayText}
    </span>
  );
}
